import { Routes } from '@angular/router';
import { AuthGuard } from './identity/authGuard';
import { SignInGuard } from './identity/signinGuard';
import { PendingChangesGuard } from '@ticomix/angular-common';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'pick-material',
    loadComponent: () => import('./pick-material/pick-material.component').then(m => m.PickMaterialComponent),
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'return-material',
    loadComponent: () => import('./return-material/return-material.component').then(m => m.ReturnMaterialComponent),
    canActivate: [AuthGuard],
    canDeactivate: [PendingChangesGuard]
  },
  {
    path: 'identity/signin',
    loadComponent: () => import('./identity/signin/signin.component').then(m => m.SignInComponent)
  },
  {
    // Location setup QR codes / deep links - handles both new sign-ups and signed-in users (no guard)
    path: 'identity/signup',
    loadComponent: () => import('./identity/signup/signup.component').then(m => m.SignUpComponent)
  },
  {
    path: 'connection-check',
    loadComponent: () => import('./connection-check/connection-check.component').then(m => m.ConnectionCheckComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'diagnostics',
    loadComponent: () => import('./diagnostics/diagnostics.component').then(m => m.DiagnosticsComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'inventory',
    loadComponent: () => import('./inventory/inventory-list.component').then(m => m.InventoryListComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'order-history',
    loadComponent: () => import('./order-history/order-history.component').then(m => m.OrderHistoryComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'order-detail/:id',
    loadComponent: () => import('./order-history/order-detail/order-detail.component').then(m => m.OrderDetailComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'identity/reset-password/:token',
    loadComponent: () => import('./identity/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'identity/reset-password',
    loadComponent: () => import('./identity/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
